import React from 'react';
import { FiGrid } from 'react-icons/fi';
import { MenuItem, LinkButton, Link } from 'core/components';
import { withRouter } from 'react-router-dom';
import { pick } from 'lodash';
import { getHashForObject } from 'app/stores/query/urlHash';

const queryProps = [
  'all_devices',
  'device_labels',
  'device_name',
  'device_sites',
  'device_types',
  'filters',
  'lookback_seconds',
  'starting_time',
  'ending_time'
];

export const generateDashboardLink = (dashboardId) => `/v4/library/dashboards/${dashboardId}`;

// the alert dashboard page loads the alert and opens the dashboard with the alert's filters
export const generateAlertDashboardLink = (dashboardId, alertId) => `/v4/alerting/dashboard/${dashboardId}/${alertId}`;

// persisted hashes keep shared dashboard links short and valid
export const getDashboardHashLink = (dashboardId, query) =>
  getHashForObject(pick(query, queryProps), undefined, { persist: true }).then(
    (hash) => `/v4/library/dashboards/${dashboardId}/hash/${hash}`
  );

const DashboardLink = ({ as, children = 'Open Dashboard', id, alertId, withIcon, history, ...rest }) => {
  const isMenuItem = as === 'MenuItem';
  const isButton = as === 'Button';
  const to = alertId ? generateAlertDashboardLink(id, alertId) : generateDashboardLink(id);

  if (isMenuItem) {
    return <MenuItem icon={withIcon ? FiGrid : null} onClick={() => history.push(to)} text={children} {...rest} />;
  }

  if (isButton) {
    return (
      <LinkButton to={to} icon={withIcon ? FiGrid : null} {...rest}>
        {children}
      </LinkButton>
    );
  }

  return (
    <Link to={to} as={as} {...rest}>
      {children}
    </Link>
  );
};

/** @type {import('react').ComponentType<any>} */
const RoutedDashboardLink = withRouter(DashboardLink);

export default RoutedDashboardLink;
